import { applyBrandingFromStorage } from './brandingApply';
import { normalizeHex } from './colorContrast';

const DEFAULT_PRIMARY = '#33475b';
const DEFAULT_SECONDARY = '#f5f4f0';

/**
 * Normalizes branding from Firestore or API into a consistent shape.
 */
export function normalizeBrandingPayload(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const primaryColor = normalizeHex(raw.primaryColor || DEFAULT_PRIMARY, DEFAULT_PRIMARY);
  const secondaryColor = normalizeHex(raw.secondaryColor || DEFAULT_SECONDARY, DEFAULT_SECONDARY);
  const appearanceTheme = raw.appearanceTheme === 'dark' ? 'dark' : 'light';
  let fontColor = raw.fontColor;
  if (fontColor != null && String(fontColor).trim() !== '') {
    fontColor = normalizeHex(fontColor, '#1a1a1a');
  } else {
    fontColor = '';
  }
  return { primaryColor, secondaryColor, fontColor, appearanceTheme };
}

/**
 * Writes platform branding to localStorage, applies CSS, and notifies listeners.
 * Call when loading from Firestore or after a successful save so every session matches the company theme.
 */
export function applyPlatformBranding(branding) {
  const b = normalizeBrandingPayload(branding);
  if (!b) return;
  localStorage.setItem('branding_primary_color', b.primaryColor);
  localStorage.setItem('branding_secondary_color', b.secondaryColor);
  if (b.fontColor) {
    localStorage.setItem('branding_font_color', b.fontColor);
  } else {
    localStorage.removeItem('branding_font_color');
  }
  localStorage.setItem('theme', b.appearanceTheme);
  document.documentElement.setAttribute('data-theme', b.appearanceTheme);
  applyBrandingFromStorage();
  window.dispatchEvent(
    new CustomEvent('brandingUpdated', {
      detail: {
        primaryColor: b.primaryColor,
        secondaryColor: b.secondaryColor,
        fontColor: b.fontColor,
        theme: b.appearanceTheme,
      },
    })
  );
}
